/* istanbul ignore file */
import * as Sentry from '@sentry/browser';
if (process.env.SENTRY_DSN) {
    console.log('Sentry enabled (global)');
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                // Ne masquer que les valeurs dans les champs texte, pas les labels, textes statiques, ou cases à cocher
                maskAllText: false,
                maskAllInputs: false,
                // Masquer uniquement les champs texte et textarea (pas checkbox, radio, select)
                // mask: ['input[type="text"]', 'input[type="email"]', 'input[type="password"]', 'input[type="tel"]', 'input[type="url"]', 'input[type="search"]', 'textarea'],
            }),
            Sentry.feedbackIntegration({
                // Configuration du widget de feedback en français
                // autoInject désactivé - activé manuellement sur certaines pages seulement
                autoInject: false,
                showBranding: false,
                colorScheme: 'light',
                // Pré-remplir avec les données de Sentry.setUser()
                useSentryUser: {
                    name: 'username',
                    email: 'email',
                },
                // Textes en français
                triggerLabel: 'Signaler un problème',
                triggerAriaLabel: 'Signaler un problème',
                formTitle: 'Signaler un problème',
                submitButtonLabel: 'Envoyer',
                cancelButtonLabel: 'Annuler',
                confirmButtonLabel: 'Confirmer',
                addScreenshotButtonLabel: "Ajouter une capture d'écran",
                removeScreenshotButtonLabel: "Retirer la capture d'écran",
                nameLabel: 'Nom',
                namePlaceholder: 'Votre nom (optionnel)',
                emailLabel: 'Courriel',
                emailPlaceholder: 'votre.courriel@exemple.com',
                isRequiredLabel: '(requis)',
                messageLabel: 'Description',
                messagePlaceholder: "Décrivez ce qui s'est passé. Qu'attendiez-vous qu'il se passe?",
                successMessageText: 'Merci! Votre rapport a été envoyé à notre équipe.',
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0,
        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
    });
}
// Export Sentry for manual error capturing if needed
export { Sentry };
// Make Sentry available globally for inline scripts
if (typeof window !== 'undefined') {
    window.Sentry = Sentry;
}
